export const userRoles = [
  { role: 'Sales Leader' },
  { role: 'Sales Rep' },
  { role: 'Marketer' },
  { role: 'Marketing Leader' },
];
